import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const OverviewSection = lazy(() => import("./OverviewSection"));
const RevolutionSection = lazy(() => import("./RevolutionSection"));
const HelpSection = lazy(() => import("./HelpSection"));
const QualitySection = lazy(() => import("./QualitySection"));

const Healthcare = () => {
  return (
    <>
      <Helmet>
        <title>
          Innovative Healthcare Solutions | Streamlined Hiring & Professional
          Development
        </title>
        <meta
          name="description"
          content="Streamline recruitment, empower staff with professional development, leverage cutting-edge technologies and improve patient care efficiency through automated processes and data-driven insights."
        />
        <meta
          name="keywords"
          content=" LENTERA healthcare services, digital healthcare tools, hospital workflow management, healthcare training programs."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <OverviewSection />
        <RevolutionSection />
        <HelpSection />
        <QualitySection />
      </Suspense>
    </>
  );
};

export default Healthcare;
